import { render, staticRenderFns } from "./AboutIntro.vue?vue&type=template&id=788d7a82&"
import script from "./AboutIntro.vue?vue&type=script&lang=js&"
export * from "./AboutIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports